var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container main",attrs:{"id":"app"}},[_vm._m(0),_c('main',[_c('transition',{attrs:{"name":"scale-fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('footer-component'),_c('popup-component')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-5"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/logo.svg"),"alt":"Albedo"}})])
}]

export { render, staticRenderFns }